import ZagUtils from './zag/zag-utils';
import Utils from './conversion/utils';

class HeaderNavMain {
  constructor() {
    if (ZagUtils.GetCurrentBP() == 'lg' || ZagUtils.GetCurrentBP() == 'md') {
      this.headerNavMainAccessibility();
    }
    if (ZagUtils.GetCurrentBP() == 'sm' || ZagUtils.GetCurrentBP() == 'xs') {
      this.headerNavMainMobile();
    }
  }

  zagOpen(elem) {
    Utils.siblings(elem.closest('li'), 'li').forEach((sibli) => {
      sibli.querySelectorAll('.mega-menu').forEach((mm) => {
        mm.classList.remove('show');
        mm.setAttribute('aria-expanded', 'false');
        mm.closest('li').classList.remove('tabbed');
      })
    })
    Utils.siblings(elem, '.mega-menu').forEach((mm) => {
      mm.classList.add('show');
      mm.setAttribute('aria-expanded', 'true');
      mm.closest('li').classList.add('tabbed');
    })
  }

  headerNavMainAccessibility() {
    var megaMenu = [];
    var megaMenuWhich = 0;
    document.querySelectorAll('header.main nav.main > ul > li:first-child a').forEach((elem) => {
      elem.setAttribute('tabindex', 0);
    });
    document.querySelectorAll('header.main nav.main .mega-menu a').forEach((elem) => {
      elem.setAttribute('tabindex', -1);
    })

    /****************************************************************
     TAB AT ANY TIME
    ****************************************************************/
    document.querySelectorAll('header.main nav.main a').forEach((elem) => {
      elem.addEventListener('keydown', (e) => {
        if (e.keyCode == 9) {
          document.querySelectorAll('header.main .mega-menu').forEach((mm) => {
            mm.classList.remove('show');
            mm.setAttribute('aria-expanded', 'false')
            mm.closest('li').classList.remove('tabbed');
          })
        }
      })
    });

    /****************************************************************
     LEVEL ONE ITEMS
    ****************************************************************/
    document.querySelectorAll('header.main .mega-menu').forEach(mm => {
      Utils.siblings(mm, 'a').forEach(toplevel => {
        toplevel.addEventListener('focus', (e) => {
          this.zagOpen(e.currentTarget);
        })
        toplevel.addEventListener('keydown', (e) => {
          /* right arrow */
          if (e.keyCode == 39) {
            e.preventDefault();
            if (!Utils.next(e.currentTarget.closest('li'), 'li').classList.contains('open-an-account')) {
              ZagUtils.zagFocus(Utils.next(e.currentTarget.closest('li'), 'li').querySelector(':scope > a'));
            }
          }
          /* left arrow */
          if (e.keyCode == 37) {
            e.preventDefault();
            ZagUtils.zagFocus(Utils.prev(e.currentTarget.closest('li'), 'li').querySelector(':scope > a'));
          }
          /* down arrow */
          if (e.keyCode == 40 && e.target == e.currentTarget) {
            e.preventDefault();
            /* build array of focus-able items */
            this.megaMenu = [];
            Utils.siblings(e.currentTarget, '.mega-menu').forEach(sib => {
              sib.querySelectorAll('a').forEach((item) => {
                this.megaMenu.push(item);
              })
            });
            this.megaMenuWhich = 0;
            ZagUtils.zagFocus(this.megaMenu[this.megaMenuWhich]);
          }

        })
      })
    });

    /****************************************************************
     MEGA MENU ITEMS
    ****************************************************************/
    document.querySelectorAll('header.main .mega-menu a').forEach((elem) => {
      elem.addEventListener('keydown', (e) => {
        /* right arrow */
        if (e.keyCode == 39) {
            e.preventDefault();
            ZagUtils.zagFocus(Utils.next(e.currentTarget.closest('.mega-menu').closest('li'), 'li').querySelector(':scope > a'));
        }
        /* left arrow */
        if (e.keyCode == 37) {
            e.preventDefault();
            ZagUtils.zagFocus(Utils.prev(e.currentTarget.closest('.mega-menu').closest('li'), 'li').querySelector(':scope > a'));
        }
        /* down arrow */
        if (e.keyCode == 40) {
            e.preventDefault();
            if (this.megaMenuWhich < this.megaMenu.length - 1) {
              this.megaMenuWhich++;
            } else {
              this.megaMenuWhich = 0;
            }
            ZagUtils.zagFocus(this.megaMenu[this.megaMenuWhich]);
        }
        /* up arrow */
        if (e.keyCode == 38) {
            e.preventDefault();
            if (this.megaMenuWhich > 0) { this.megaMenuWhich--; }
            else { this.megaMenuWhich = this.megaMenu.length - 1; }
            ZagUtils.zagFocus(this.megaMenu[this.megaMenuWhich]);
        }
      });
    })
  }

  headerNavMainMobile() {
    document.querySelectorAll('nav.main > ul > li > a').forEach(item => {
      item.addEventListener('click', (e) => {
        if (e.currentTarget.closest('li').querySelectorAll('.mega-menu').length > 0) {

          if (!e.currentTarget.closest('li').classList.contains('active')) {
            e.preventDefault();
            e.currentTarget.closest('li').classList.add('active')
            e.currentTarget.closest('li').querySelector('.mega-menu').style.display = 'block'
            Utils.siblings(e.currentTarget.closest('li'), 'li').forEach((sib) => {
              if (e.currentTarget.closest('li') != sib) {
                sib.classList.remove('active')
                sib.querySelector('.mega-menu').style.removeProperty('display')
              }
            })
          }
        }
      });
    })

  }
}

document.addEventListener('DOMContentLoaded', () => {
  const headerNavMain = new HeaderNavMain();
})
